import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

export class GetTrackingPhoneDealerService extends Service {
  constructor({httpRepository, sessionStorageRepository, requestValueObjectFactory}) {
    super()
    this._httpRepository = httpRepository
    this._sessionStorageRepository = sessionStorageRepository
    this._requestValueObjectFactory = requestValueObjectFactory
  }

  _addSessionTo(trackingPhoneRequestVO) {
    const sessionId = this._sessionStorageRepository.getTrackingPhone()
    const hasSessionId = Boolean(sessionId)

    if (!hasSessionId) return trackingPhoneRequestVO

    const params = trackingPhoneRequestVO.toJSON()

    return this._requestValueObjectFactory({
      ...params,
      sessionId
    })
  }

  @inlineError
  async execute({trackingPhoneRequestParamsVO}) {
    const trackingPhoneRequestWithSessionVO = this._addSessionTo(trackingPhoneRequestParamsVO)

    const [error, trackingPhoneVO] = await this._httpRepository.getTrackingPhone({
      trackingPhoneRequestParamsVO: trackingPhoneRequestWithSessionVO
    })

    if (error) return Promise.reject(error)

    this._sessionStorageRepository.setTrackingPhone({
      sessionId: trackingPhoneVO.getSessionId()
    })

    return trackingPhoneVO
  }
}
